import { useState, useEffect } from 'react'

export interface ModalProps {
  title: string
  bgColor?: string
  titleColor?: string
  btnSubmitLabel?: string
  btnSubmitBgColor?: string
  btnSubmitTextColor?: string
  hideFooter?: boolean
  isBtnSubmitDisabled?: boolean
  isCentered?: boolean
  children: React.ReactNode
  onClose: () => void
}

export const useModal = (props: ModalProps) => {
  const { onClose } = props
  const [isVisible, setIsVisible] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  const handleClose = () => {
    setIsVisible(false)
    setIsClosing(true)
    setTimeout(() => {
      onClose()
    }, 300)
  }

  useEffect(() => {
    const timeout = setTimeout(() => setIsVisible(true), 10)
    return () => clearTimeout(timeout)
  }, [])

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') handleClose()
    }
    document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [])

  return {
    ...props,
    isVisible,
    isClosing,
    handleClose,
  }
}
